"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { IconTicket } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import type { CouponSourceType } from "@/features/analytics/types/event.type";
import { AddDiscountFormButton } from "@/features/cart/components/discount/add-discount-form-button";
import type { AddDiscountErrorDetails } from "@/features/cart/hooks/use-add-discount";
import { useCartStoreService } from "@/features/cart/hooks/use-cart-store-service";
import type { CartStoreType } from "@/features/cart/types/cart-store-type";

type AddDiscountFormProps = {
  availableCodes: number;
  type?: CartStoreType;
  separator?: boolean;
  addDiscount: (code: string, source: CouponSourceType) => Promise<void>;
  isError: boolean;
  info: string | null;
  isPending: boolean;
  errorDetails: AddDiscountErrorDetails | null;
  isOnList: boolean;
};

export const AddDiscountForm = ({
  availableCodes,
  type,
  separator = true,
  addDiscount,
  isError,
  isPending,
  isOnList,
}: AddDiscountFormProps) => {
  const t = useTranslations();
  const { cartStore, isMultidiet } = useCartStoreService({ type });
  const form = useForm({
    resolver: zodResolver(
      z.object({
        discount: z.string().min(cartStore.discountCode ? 1 : 0),
      }),
    ),
    defaultValues: {
      discount: "",
    },
  });

  useEffect(() => {
    form.setValue("discount", "");
  }, [cartStore.discountCode, form]);

  const handleSubmit = async () => {
    await addDiscount(form.getValues("discount"), "koszyk_recznie");
  };
  const discountValue = form.watch("discount");
  return (
    <>
      <div>
        {(cartStore.items.length > 0 && availableCodes > 1 && !isMultidiet) ||
          (isMultidiet && cartStore.discountCode && (
            <p className="text-xs">{t("diets.discountCodesMaxUses")}</p>
          ))}

        <form
          className="relative flex items-center gap-2"
          id="add-discount-form"
          onSubmit={form.handleSubmit(handleSubmit)}
        >
          <div className="relative flex-1">
            <Input
              {...form.register("discount")}
              className="h-14 rounded-xl pr-20 placeholder:text-sm"
              defaultValue={isOnList ? "" : cartStore.discountCode || ""}
              placeholder={t("checkout.order.discountPlaceholder")}
              type="text"
            />
            {!discountValue && (
              <IconTicket className="absolute top-1/2 right-4 h-6 w-6 -translate-y-1/2" />
            )}
          </div>
          <AddDiscountFormButton
            isError={isError}
            pending={isPending}
            submitted={false}
          />
        </form>
      </div>

      {separator && <Separator />}
    </>
  );
};
